export const ACTION_TYPES = {
  APP_SET_DATA: "app-set-data",
  CLEAR_ERROR_MESSAGE: "clear-error-message",
  SET_STEP_IS_VALID: "set-step-is-valid",
  SET_WARNINGS: "set-warnings",
  SET_SELECTED_DATE: "set-selected-date",
  SET_SELECTED_TIMESLOT: "set-selected-timeslot",
  SET_SELECTED_CURRENCY: "set-selected-currency",
  SET_ADMISSION_TICKETS: "set-admission-tickets",
  SET_ADDON_TICKETS: "set-addon-tickets",
  SET_ACTIVE_STEP: "set-active-step",
  REMOVE_ADDON_TICKET_TIMESLOT: "remove-addon-ticket-timeslot",
  RESET_SUMMARY_ADDON_TICKETS: "reset-summary-addon-tickets",
  RESET_SUMMARY_ADMISSION_TICKETS: "reset-summary-admission-tickets",
  UPDATE_CART: "update-cart",
  RESTORE_CART: "restore-cart",
  RESTORE_ADDONS: "restore-addons",
  SET_TOTALS: "set-totals",
  SET_CODE: "set-code",
  ADD_SELECTED_TIMESLOT: "add-selected-timeslot",
  REMOVE_SELECTED_TIMESLOT: "remove-selected-timeslot",
  CLEAR_SELECTED_TIMESLOTS: "clear-selected-timeslots",
  SET_CC_CARDS: "set-cc-cards",
  SET_LOGIN_SESSION_DATA: "set-login-session-data",
  REMOVE_GIFT_CARD_VARIANT: "remove-gift-card-variant",
};
